import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-redeem-modal',
  templateUrl: './redeem-modal.component.html',
  styleUrls: ['./redeem-modal.component.scss']
})
export class RedeemModalComponent {
  @Input() currencyCode: string = 'ILS';
  @Output() onRedeemAction = new EventEmitter<{ code: string; amount: number }>();
  @Output() onSuccess = new EventEmitter<void>();
  @ViewChild('template') template!: TemplateRef<any>;

  public redeemCode: string = '';
  public redeemAmount: number = 0;
  public redeemDone = false;
  public invalidCode = false;
  public showAmountSelection = true;
  public showCodeInput = false;
  modalRef?: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) {}

  public open() {
    this.reset();
    this.modalRef = this.modalService.show(this.template);
  }

  public close() {
    this.modalRef?.hide();
    this.reset();
  }

  private reset() {
    this.redeemDone = false;
    this.invalidCode = false;
    this.redeemCode = '';
    this.redeemAmount = 0;
    this.showAmountSelection = true;
    this.showCodeInput = false;
  }

  public selectAmount(amount: number) {
    this.redeemAmount = amount;
  }

  public proceedToScan() {
    const amount = Number(this.redeemAmount);
    if (amount >= 1 && amount <= 1000) {
      this.redeemAmount = amount;
      this.showAmountSelection = false;
      this.showCodeInput = true;
    }
  }

  public onRedeem() {
    const amount = Number(this.redeemAmount);
    this.spinner.show();
    this.onRedeemAction.emit({ code: this.redeemCode, amount: amount });
  }

  public handleRedeemSuccess() {
    this.redeemDone = true;
    this.spinner.hide();
    this.onSuccess.emit();
  }

  public handleRedeemError() {
    this.invalidCode = true;
    this.spinner.hide();
  }
}

